import * as types from "./dndUploadProgressTypes";

export const initState: types.DndUploadProgressState = {};

const dndUploadProgressReducers = (
  state: types.DndUploadProgressState = initState,
  action: types.DndUploadProgressAnyAction | { type: string }
): types.DndUploadProgressState => {
  switch (action.type) {
    case types.DND_UPLOAD_START: {
      const a = action as types.DndUploadStartAction;
      return {
        ...state,
        [a.uploadId]: {
          uploadId: a.uploadId,
          fileName: a.fileName,
          source: a.source,
          startedAt: a.startedAt,
          progress: 0,
          status: "uploading"
        }
      };
    }

    case types.DND_UPLOAD_PROGRESS: {
      const a = action as types.DndUploadProgressAction;
      const existing = state[a.uploadId];
      if (!existing || existing.status !== "uploading") {
        return state;
      }
      const firstProgressAt =
        existing.firstProgressAt == null && a.progress > 0
          ? Date.now()
          : existing.firstProgressAt;
      return {
        ...state,
        [a.uploadId]: {
          ...existing,
          progress: a.progress,
          firstProgressAt
        }
      };
    }

    case types.DND_UPLOAD_COMPLETE: {
      const a = action as types.DndUploadCompleteAction;
      const existing = state[a.uploadId];
      if (!existing) return state;
      return {
        ...state,
        [a.uploadId]: {
          ...existing,
          progress: 100,
          status: "success",
          completedAt: a.completedAt
        }
      };
    }

    case types.DND_UPLOAD_FAIL: {
      const a = action as types.DndUploadFailAction;
      const existing = state[a.uploadId];
      if (!existing) return state;
      return {
        ...state,
        [a.uploadId]: {
          ...existing,
          status: "error",
          errorMessage: a.errorMessage,
          completedAt: a.completedAt
        }
      };
    }

    case types.DND_UPLOAD_DISMISS: {
      const a = action as types.DndUploadDismissAction;
      if (!state[a.uploadId]) return state;
      const next = { ...state };
      delete next[a.uploadId];
      return next;
    }

    case types.DND_UPLOAD_DISMISS_ALL_COMPLETED: {
      const next: types.DndUploadProgressState = {};
      let changed = false;
      for (const key of Object.keys(state)) {
        const entry = state[key];
        if (!entry) continue;
        if (entry.status === "success") {
          changed = true;
          continue;
        }
        next[key] = entry;
      }
      return changed ? next : state;
    }

    default:
      return state;
  }
};

export default dndUploadProgressReducers;
